import { render, staticRenderFns } from "./ScoreQuestion.vue?vue&type=template&id=dbabe8b2&scoped=true"
import script from "./ScoreQuestion.vue?vue&type=script&lang=js"
export * from "./ScoreQuestion.vue?vue&type=script&lang=js"
import style0 from "./ScoreQuestion.vue?vue&type=style&index=0&id=dbabe8b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbabe8b2",
  null
  
)

export default component.exports